import { render } from "./AppRoot.vue?vue&type=template&id=c19395a8"
import script from "./AppRoot.vue?vue&type=script&lang=js"
export * from "./AppRoot.vue?vue&type=script&lang=js"

import "./AppRoot.vue?vue&type=style&index=0&id=c19395a8&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__